import React from "react";

const Hide = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none">
    <path
      fill="#8B929A"
      d="M15.029 12.642C16.944 10.936 18 9 18 9s-3.375-6.188-9-6.188a7.907 7.907 0 0 0-3.14.662l.868.867A6.687 6.687 0 0 1 9 3.937c2.384 0 4.364 1.315 5.814 2.765A14.77 14.77 0 0 1 16.68 9a14.77 14.77 0 0 1-1.867 2.298c-.185.185-.38.369-.582.547l.797.797Z"
    />
    <path
      fill="#8B929A"
      d="M12.71 10.323A3.938 3.938 0 0 0 7.677 5.29l.925.925a2.813 2.813 0 0 1 3.183 3.183l.925.925ZM9.398 11.784l.925.925A3.938 3.938 0 0 1 5.29 7.676l.925.926a2.813 2.813 0 0 0 3.183 3.183Z"
    />
    <path
      fill="#8B929A"
      d="M3.768 6.154c-.202.179-.396.362-.582.548A14.776 14.776 0 0 0 1.32 9a14.777 14.777 0 0 0 1.867 2.298c1.45 1.45 3.43 2.764 5.814 2.764.805 0 1.564-.15 2.272-.404l.867.867A7.907 7.907 0 0 1 9 15.187C3.375 15.187 0 9 0 9s1.056-1.936 2.971-3.642l.797.796ZM15.352 16.148l-13.5-13.5.796-.796 13.5 13.5-.796.796Z"
    />
  </svg>
);

export default Hide;
